const PRIORITY = {
    low: { bg: "#333333", fg: "#A1A1AA", label: "LOW" },
    medium: { bg: "#882D00", fg: "#FF5500", label: "MEDIUM" },
    high: { bg: "#FF5500", fg: "#050505", label: "HIGH" },
    critical: { bg: "#FF1744", fg: "#FFFFFF", label: "CRITICAL" },
};

export default function PriorityPill({ value, onClick }) {
    const p = PRIORITY[value] || PRIORITY.medium;
    return (
        <button
            onClick={onClick}
            className="inline-flex items-center justify-center px-2 py-1 min-w-[80px] font-mono text-[10px] tracking-[0.18em] font-bold hover:opacity-90 transition-opacity"
            style={{ backgroundColor: p.bg, color: p.fg }}
            type="button"
        >
            {p.label}
        </button>
    );
}

export const PRIORITY_LIST = Object.keys(PRIORITY);
export const PRIORITY_META = PRIORITY;
